import type {
  ApiPagingResponseData,
  ApiResponse,
  HttpClient,
} from '@remodeling/base';
import _ from 'lodash';
import querystring from 'query-string';
import {
  EventDetailResponseData,
  EventItem,
  GetEventConsultChannelInfoRequest,
  GetEventDetailRequest,
  GetEventListRequest,
} from '../../model';

export class GetEventListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetEventListRequest) {
    const query = querystring.stringify(req);
    return await this.httpClient.request<
      ApiResponse<ApiPagingResponseData<EventItem>>
    >({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/events?${query}`,
    });
  }
}

export class GetEventDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetEventDetailRequest) {
    const query = querystring.stringify(_.omit(req, 'shpNo'));
    return await this.httpClient.request<ApiResponse<EventDetailResponseData>>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/events/${req.shpNo}?${query}`,
    });
  }
}

export class GetEventConsultChannelInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetEventConsultChannelInfoRequest) {
    return await this.httpClient.request<ApiPagingResponseData<EventItem>>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/content-service/api/v1/events/${req.shpNo}/consult-channel-info`,
    });
  }
}
